/**
 * Determines if a color is dark based on its hex value.
 * @param {string} hex
 * @returns {boolean}
 */
export function isColorDark(hex: string): boolean {
  if (!hex || typeof hex !== 'string' || !/^#([0-9A-Fa-f]{3}){1,2}$/.test(hex)) {
    console.warn(`Invalid hex color: ${hex}`)

    return false
  }

  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)

  const isRDark = r < 30
  const isGDark = g < 30
  const isBDark = b < 40

  return isRDark && isGDark && isBDark
}
